import ManfrediteComponent from 'components/manfredite/ManfrediteComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type ManfreditePageProps = WithBaseUrl;

const ManfreditePage: React.FC<ManfreditePageProps> = ({ baseUrl }) => {
  const { t } = useI18n('manfredite');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('page_title')}
        desc={t('intro.description')}
        url={APP_URLS.beManfredite}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_manfredite.png'
        )}`}
      />
      <ManfrediteComponent />
    </>
  );
};

export default ManfreditePage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'manfredite'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
